import { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
  ogImage?: string;
  twitterCard?: string;
  schemaData?: object[];
}

export default function SEO({
  title = 'ASMR免费网页 - 在线免费收听ASMR助眠白噪音',
  description = 'ASMR免费网页为您提供海量ASMR音频在线免费收听，无需下载、无需注册，涵盖助眠、解压、专注等多种场景音频。',
  keywords = 'ASMR免费网页,ASMR在线免费听,免费ASMR助眠音频,ASMR白噪音网站,ASMR解压放松,ASMR专注学习音效,在线ASMR无需注册',
  canonicalUrl = 'https://asmr-free.com/',
  ogType = 'website',
  ogTitle,
  ogDescription,
  ogUrl,
  ogImage,
  twitterCard = 'summary_large_image',
  schemaData = [],
}: SEOProps) {
  useEffect(() => {
    const resolvedOgTitle = ogTitle || title;
    const resolvedOgDescription = ogDescription || description;
    const resolvedOgUrl = ogUrl || canonicalUrl;

    document.title = title;

    const setMeta = (name: string, content: string, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);
    setMeta('og:type', ogType, true);
    setMeta('og:title', resolvedOgTitle, true);
    setMeta('og:description', resolvedOgDescription, true);
    setMeta('og:url', resolvedOgUrl, true);
    if (ogImage) setMeta('og:image', ogImage, true);
    setMeta('twitter:card', twitterCard);
    setMeta('twitter:title', resolvedOgTitle);
    setMeta('twitter:description', resolvedOgDescription);

    const existingCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (existingCanonical) {
      existingCanonical.setAttribute('href', canonicalUrl);
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = canonicalUrl;
      document.head.appendChild(link);
    }

    const existingScripts = document.querySelectorAll('script[data-seo-schema]');
    existingScripts.forEach((s) => s.remove());

    schemaData.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-schema', `schema-${index}`);
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });
  }, [title, description, keywords, canonicalUrl, ogType, ogTitle, ogDescription, ogUrl, ogImage, twitterCard, schemaData]);

  return null;
}